import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  gltfPath: { data: '', loading: false },
  gltfPolicy: { data: null, loading: false },
  gltfExisted: { data: false, loading: false },
  canPreview: { data: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
